module.exports = __webpack_public_path__ + "7c6d35f2e8578c00afecfd5e89e27aad.png";